import { TopMenuDropdown } from 'editor/src/store/app/types';
import { RootState } from 'editor/src/store/index';

const isTopMenuDropdownVisible = (state: RootState, dropDownName: TopMenuDropdown) =>
  state.app.dropdowns.activeTopMenuDropdown === dropDownName;

export default isTopMenuDropdownVisible;
